import { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { exchangeGuestClaimCode } from "../api/doarPlatformApi";

function claimTargetForCurrentSurface() {
  const host = String(window.location.hostname || "").toLowerCase();
  const surface = String(process.env.REACT_APP_PUBLIC_SURFACE || "").toLowerCase();
  if (host === "doarspace.com" || host === "www.doarspace.com" || host === "localhost-space" || surface === "space") return "space";
  if (host === "thedoar.com" || host === "www.thedoar.com" || host === "localhost-marketplace" || surface === "marketplace") return "marketplace";
  return null;
}

export default function GuestClaimBridge() {
  const { token } = useContext(AuthContext);

  useEffect(() => {
    if (!token) return undefined;

    const params = new URLSearchParams(window.location.search);
    const claim = params.get("claim");
    if (!claim) return undefined;

    let live = true;
    window.dispatchEvent(new CustomEvent("doar:guest-claim-started"));

    const target = claimTargetForCurrentSurface();
    if (!target) return undefined;

    exchangeGuestClaimCode(claim, target)
      .then((result) => {
        if (!live) return;
        params.delete("claim");
        params.delete("guest");
        const query = params.toString();
        const next = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash || ""}`;
        window.history.replaceState({}, "", next);
        window.dispatchEvent(new CustomEvent("doar:guest-claimed", {
          detail: { objectIds: result.objectIds || [] },
        }));
      })
      .catch((error) => {
        if (!live) return;
        window.dispatchEvent(new CustomEvent("doar:guest-claim-failed", {
          detail: {
            message: error?.response?.data?.message || "This private continuation link could not be claimed.",
          },
        }));
      });

    return () => { live = false; };
  }, [token]);

  return null;
}
